import { GMAIL_URL, getMSOffice365Url, getMSVisualStudioOfficeToolsUrl // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase
} from '../utils/urls';

const isSalesExtensionSignup = ({
  queryParams
}) => {
  return queryParams['utm_medium'] === 'marketplaces' && queryParams['opt_sidebar'] === 'sales-extension-signup';
};

export const shouldNotSkipSetupUi = ({
  redirectUrl,
  queryParams = {},
  signupIntent
}) => {
  return !isSalesExtensionSignup({
    queryParams
  }) && !((queryParams['skip_setup'] === 'true' || signupIntent === 'marketingFreeEmail') && redirectUrl !== getMSOffice365Url() && redirectUrl !== getMSVisualStudioOfficeToolsUrl());
};
export const maybeGetSalesReplacementRedirectUrl = ({
  redirectUrl,
  queryParams
}) => {
  if (isSalesExtensionSignup({
    queryParams
  })) {
    return GMAIL_URL;
  }

  return redirectUrl;
};